<template>
<div>
  <div v-html="previewHtml" />

  <div class="row">
    <div class="col-5">
      <TextField
          :scope="[...scope, 'url']"
          v-model:model-value="url"
          disable-margin
      />
    </div>
  </div>
</div>
</template>

<script lang="ts">
import { defineComponent, PropType } from "vue";
import { humanize, scopeToId, scopeToName } from "@/lib/candidacy/form_builder/utils";
import TextField from "@/components/backend/candidacy/form_builder/form_items/shared/TextField.vue";
import LocaleStringField from "@/components/backend/candidacy/form_builder/form_items/shared/LocaleStringField.vue";
import FormGroup from "@/components/backend/candidacy/form_builder/form_items/shared/FormGroup.vue";
import type { PageBlocksVideo } from "@/types";

export default defineComponent({
  name: "Video",
  emits: ["update:pageBlock"],
  components: {FormGroup, LocaleStringField, TextField},
  methods: { scopeToName, scopeToId, humanize },
  props: {
    scope: {
      type: Array as PropType<string[]>,
      required: true,
    },
    pageBlock: {
      type: Object as PropType<PageBlocksVideo>,
      required: true,
    },
  },
  data({ pageBlock }) {
    return {
      url: pageBlock.data.url || "",
    }
  },
  computed: {
    altData() {
      return this.$t("js.accessibility.embedded_video");
    },
    previewHtml() {
      if (!this.url) return "";

      return `
        <div style="padding:56.25% 0 0 0;position:relative;">
          <iframe src="${this.url}" title="${this.altData}" style="position:absolute;top:0;left:0;width:100%;height:100%;"></iframe>
        </div>
        `;
    }
  },
});
</script>
